@charset "UTF-8";
._searchButton_cxrzp_2 {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 9px 12px 6px;
  color: #ffffff;
  background-color: transparent;
  box-sizing: content-box;
  border: none;
  cursor: pointer; }

._searchButton_cxrzp_2 ._searchLabel_cxrzp_13 {
  max-width: 90px;
  color: #ffffff;
  cursor: pointer; }

._searchButton_cxrzp_2 ._searchBubble_cxrzp_18 {
  display: none;
  position: relative;
  width: 0;
  height: 0;
  z-index: 99999;
  top: -21px;
  left: 22px; }

._searchButton_cxrzp_2 ._searchBubble_cxrzp_18 .bubble-content {
  flex-direction: column;
  align-items: unset;
  width: 240px;
  white-space: normal; }

._searchButton_cxrzp_2:hover {
  text-decoration: underline; }

._searchButton_cxrzp_2:hover ._searchBubble_cxrzp_18 {
  display: block; }

._searchButton_cxrzp_2 svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 4px; }

._searchButton_cxrzp_2 svg > path {
  fill: #ffffff; }

._searchSeparator_cxrzp_48 {
  background: #d9e1e8;
  border: none;
  width: calc(100% - 43px);
  height: 1px;
  margin: 0 18px;
  opacity: 0.5; }

._newLabel_cxrzp_56 {
  color: red;
  position: absolute;
  bottom: 0;
  left: 5px;
  padding: 5px;
  background: #eeeeee;
  border-width: 1px;
  border-style: solid;
  border-color: #aaaaaa;
  border-image: initial; }

._addPanelCategoriesContainer_cxrzp_68 {
  position: relative;
  background-color: #f7f8f8;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  max-width: 186px;
  border-right: 1px solid #dfe5eb; }

._addPanelCategoriesContainer_cxrzp_68._withSearch_cxrzp_77 ._addPanelCategoryList_cxrzp_77 {
  max-height: calc( 100% - 30px - 9px - 6px * 2 - 14px - 1px);
  height: 100%;
  padding-top: 6px; }

._addPanelCategoriesContainer_cxrzp_68:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 13px;
  pointer-events: none;
  background: linear-gradient(to top, #f7f8f8, rgba(247, 248, 248, 0)); }

._addPanelCategoryList_cxrzp_77 {
  display: inline-block;
  height: 100%;
  box-sizing: border-box;
  padding: 12px 0;
  vertical-align: top;
  max-width: 186px;
  overflow-y: auto; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 {
  height: calc(4.34783% - 0px);
  cursor: pointer;
  font-size: 24px;
  margin: 0;
  max-height: 36px;
  min-height: 25px;
  padding: 0 12px;
  position: relative; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111 {
  border-radius: 20px;
  display: inline-block;
  height: 96%;
  max-height: 30px;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  max-width: 145px; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111._isSelected_cxrzp_121, ._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111:not(._isSelected_cxrzp_121):hover {
  box-shadow: none; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111._isSelected_cxrzp_121 {
  background-color: #d6e6fe; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111._isSelected_cxrzp_121 ._categoryName_cxrzp_111 {
  color: #116dff; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111:not(._isSelected_cxrzp_121):hover {
  background-color: #e7f0ff; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111:not(._isSelected_cxrzp_121):hover ._categoryName_cxrzp_111 {
  color: #116dff; }

._addPanelCategoryList_cxrzp_77 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111 > ._categoryName_cxrzp_111 {
  color: #000624;
  display: inline-block;
  position: relative;
  height: 24px;
  top: calc(50% - 24px / 2 - 6px);
  cursor: pointer; }

._addPanelCategoryList_cxrzp_77 > ._categoryDivider_cxrzp_144 {
  height: auto;
  cursor: auto;
  margin-top: 8px;
  margin-bottom: 0;
  min-height: 11px; }

._addPanelCategoryList_cxrzp_77 > ._categoryDivider_cxrzp_144 > hr {
  width: calc(100% - 30px);
  height: 1px;
  opacity: 0.5;
  border-top: 1px solid #dfe5eb;
  margin-left: 12px;
  margin-top: 10px;
  border-bottom: none; }

._addPanelSectionsListContainer_cxrzp_160 {
  position: relative;
  background-color: #fff;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  max-width: 186px;
  border-right: 1px solid #dfe5eb; }

._addPanelSectionsList_cxrzp_160 {
  background-color: #fff;
  display: inline-block;
  height: 100%;
  box-sizing: border-box;
  padding: 12px 0;
  overflow-y: auto;
  vertical-align: top;
  border-right: 1px solid #dfe5eb; }

._addPanelSectionsList_cxrzp_160 > li._sectionHeader_cxrzp_179:first-of-type {
  margin-top: 0; }

._addPanelSectionsList_cxrzp_160 > ._sectionHeader_cxrzp_179 {
  max-height: 30px;
  min-height: 18px;
  height: calc(4.34783% - 0px);
  padding-left: 12px;
  position: relative; }

._addPanelSectionsList_cxrzp_160 > ._sectionHeader_cxrzp_179 > ._categoryGroupTitle_cxrzp_189 {
  position: relative;
  height: 18px;
  top: calc(50% - 18px / 2);
  font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.64;
  letter-spacing: normal;
  padding-left: 12px;
  padding-right: 18px;
  text-transform: uppercase;
  color: #868aa5; }

._addPanelSectionsList_cxrzp_160 > ._sectionDivider_cxrzp_205 {
  max-height: 16px;
  margin-top: 10px;
  height: calc(4.34783% - 0px); }

._addPanelSectionsList_cxrzp_160 > ._sectionDivider_cxrzp_205 > ._groupDivider_cxrzp_210 {
  height: 1px;
  width: calc(100% - 48px);
  opacity: 0.3; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 {
  color: #3b4057;
  cursor: pointer;
  font-size: 24px;
  max-height: 36px;
  min-height: 25px;
  padding: 0 12px;
  position: relative;
  height: calc(4.34783% - 0px); }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111 {
  border-radius: 20px;
  display: inline-block;
  height: 96%;
  max-height: 30px;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  max-width: 145px; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111._isSelected_cxrzp_121 {
  background-color: #d6e6fe;
  box-shadow: none; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111._isSelected_cxrzp_121 ._categoryName_cxrzp_111 {
  color: #116dff; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111:not(._isSelected_cxrzp_121):hover {
  background-color: #e7f0ff; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111:not(._isSelected_cxrzp_121):hover ._categoryName_cxrzp_111 {
  color: #116dff; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111 > ._categoryName_cxrzp_111 {
  display: inline-block;
  position: relative;
  height: 24px;
  top: calc(50% - 24px / 2 - 6px);
  cursor: pointer;
  color: #000624; }

._addPanelSectionsList_cxrzp_160 > ._category_cxrzp_101 > ._categoryNameWrapper_cxrzp_111 > ._categoryGroupTitle_cxrzp_189 {
  display: inline-block; }
